import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GnTableComponent} from './table.component';
import {GnTableColumnDirective} from './table-column.directive';
import {GnMessageServiceModule} from '../message-service/message-service.module';
import {NzTableModule} from 'ng-zorro-antd/table';

@NgModule({
  declarations: [
    GnTableComponent,
    GnTableColumnDirective
  ],
  exports: [
    GnTableComponent,
    GnTableColumnDirective
  ],
  imports: [
    CommonModule,
    NzTableModule,
    GnMessageServiceModule
  ]
})
export class GnTableModule {
}
